// extracted by mini-css-extract-plugin
module.exports = {"AccountHeader":"AccountHeader_AccountHeader__2w7Zd","CloseIcon":"AccountHeader_CloseIcon__4qrWE"};